import type { Dataset, DatasetUpdateVariables } from "@/entities/dataset";

import { useTranslation } from "react-i18next";

import DatasetEditForm from "@/modules/dataset/dataset-edit-form";
import { useDatasetsMutatorSync } from "@/modules/datasets/datasets-mutator";
import { useSidePanel } from "@/modules/side-panel";

export const useDatasetEditMutator = () => {
  const { t } = useTranslation();
  const { openSidePanel } = useSidePanel();

  const { addMutatorItem } = useDatasetsMutatorSync();

  const onFormApplyClick = (
    dataset: Dataset,
    variables: DatasetUpdateVariables
  ) => {
    addMutatorItem({
      mutationType: "update",
      datasetType: dataset.type,
      datasetId: dataset.id,
      variables,
    });
  };

  const editDataset = (dataset: Dataset) => {
    openSidePanel({
      title: t("dataset:update.label"),
      component: (
        <DatasetEditForm
          dataset={dataset}
          onApplyClick={(values) => onFormApplyClick(dataset, values)}
        />
      ),
    });
  };

  return {
    editDataset,
  };
};
